export const FETCH_USERS_LIST_REQUEST = 'FETCH_USERS_LIST_REQUEST'
export const FETCH_USERS_LIST_SUCCESS = 'FETCH_USERS_LIST_SUCCESS'
export const FETCH_USERS_LIST_FAILURE = 'FETCH_USERS_LIST_FAILURE'

export const REMOVE_USER_REQUEST = 'REMOVE_USER_REQUEST'
export const REMOVE_USER_SUCCESS = 'REMOVE_USER_SUCCESS'
export const REMOVE_USER_FAILURE = 'REMOVE_USER_FAILURE'

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST'
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS'
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE'

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE'

export const USER_CLEAR_ERROR = 'USER_CLEAR_ERROR'
